import React from 'react';
import DestinationSectionLoader from './destinationSectionLoader';

const TopSunquestsDetailSection = (prop) => {

    // https://www.redtag.ca/images/hotels/default.jpg
    const defaultImage = 'https://travel-img-assets.s3.us-west-2.amazonaws.com/no-image/no-image-500x300.png';
    const topSunquests = prop.topSunquests;
    const topItems = prop.topItems;

    return (
        <>
           { topSunquests ?
                <>
                    { topItems !== undefined && topItems !== null && topItems.length > 0 ?
                        <>
                            {topItems.map((item, key) => {
                                if(item.name != undefined ) {
                                    return (
                                        <div className="col-6 col-sm-6 col-xl col-lg-4 col-md-4 mb-3 mb-xl-0">
                                            <div className="rounded-sm">
                                                <button className="btn-unstyled deal-list-card text-decoration-none" style={{cursor: "default"}}>
                                                    <div className="position-relative w-100 overflow-hidden">
                                                        <img className="w-100 object-fit-cover rounded-4" height="169" src={(item.image != undefined && item.image != '') ? item.image : defaultImage} data-was-processed="true" />
                                                        <div className="position-absolute left-bottom py-2 px-2 rounded-sm bg-black-transparent">
                                                            <h6 className="text-white text-center mb-0 font-size-md">
                                                                {(item.long != undefined && item.long != '') ? (item.name + ' in ' + item.long) : item.name}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    );
                                }  
                            })}
                        </>
                    :
                        null
                    }
                </>
            : null }
        </>
    );
};

export default TopSunquestsDetailSection;
